import { render } from "./matchingDetail.vue?vue&type=template&id=e16c7fb4&scoped=true"
import script from "./matchingDetail.vue?vue&type=script&lang=js"
export * from "./matchingDetail.vue?vue&type=script&lang=js"

import "./matchingDetail.vue?vue&type=style&index=0&id=e16c7fb4&lang=scss"
import "./matchingDetail.vue?vue&type=style&index=1&id=e16c7fb4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e16c7fb4"],['__file',"src/views/exhibitionManage/components/matchingDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e16c7fb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e16c7fb4', __exports__)) {
    console.log('reload')
    api.reload('e16c7fb4', __exports__)
  }
  
  module.hot.accept("./matchingDetail.vue?vue&type=template&id=e16c7fb4&scoped=true", () => {
    console.log('re-render')
    api.rerender('e16c7fb4', render)
  })

}


export default __exports__